import axios from 'axios';

export default {
    methods: {
        getActiveVouchers() {
            axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/active-vouchers")
                .then((response) => {
                    this.active_vouchers = response.data.active_vouchers;
                })
                .catch((error) => {
                    if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
                })
        },
        getVouchersAmount() {
            axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/voucher-amounts")
                .then((response) => {
                    this.voucher_amounts = response.data.voucher_amounts;
                })
                .catch((error) => {
                    if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
                })
        },
        getUsedVouchersHistory() {
            axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/voucher-history")
                .then((response) => {
                    this.used_sum = response.data.used_sum;
                    this.saved_money = response.data.saved_money;
                })
                .catch((error) => {
                    if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
                })
        }
    }
}